var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('b-modal', {
    attrs: {
      "id": "ViewForwardEmail",
      "centered": "",
      "hide-header-close": "",
      "size": "md"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "popUp-header text-center w-100",
          staticStyle: {
            "border-bottom": "0px !important"
          }
        }, [_c('h4', {
          staticClass: "heading-size"
        }, [_vm._v("Forward Email")])]), _c('b-button', {
          staticClass: "position-absolute",
          staticStyle: {
            "right": "1rem",
            "top": "1rem"
          },
          attrs: {
            "variant": "close",
            "aria-label": "Close"
          },
          on: {
            "click": function click($event) {
              _vm.internalShow = false;
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              _vm.internalShow = false;
            }
          }
        }, [_vm._v(" Close ")]), _c('b-button', {
          staticClass: "univ-btn w-auto p-2 h-100 mt-1",
          attrs: {
            "disabled": !_vm.email
          },
          on: {
            "click": function click($event) {
              return _vm.forward();
            }
          }
        }, [_vm._v(" Forward ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.internalShow,
      callback: function callback($$v) {
        _vm.internalShow = $$v;
      },
      expression: "internalShow"
    }
  }, [_c('div', {}, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email Address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter one or more email address separated by comma or semicolon"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }
    }
  })])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }